import moment from 'moment-timezone';

const getHourlyIntervalFormat = (from, to) => {
  let start = moment(from);
  let end = moment(to);
  if (start.get('minute') === 0 || start.isSame(end, 'hour')) {
    start = moment(start).set({ minute: 0, second: 0 });
  } else {
    const startHour = start.get('hour');
    start = moment(start).set({ hour: startHour + 1, minute: 0, second: 0 });
  }

  /**
   * for time intervals earlier than 31 days, and if the end time ends with 59 mins (which we get from datepicker)
   * add 1 minute to the end time to accomodate the last hour of the interval
   * No need to add for durations that do not end at 59 mins
   */
  
  if (end.minute() === 59) {
    end = end.add(1, 'minute');
  }

  return {
    start,
    end,
  };
};

export default getHourlyIntervalFormat;
